"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginSuccessed = exports.useStore = void 0;
const react_light_state_1 = __importDefault(require("react-light-state"));
const consts_1 = require("../consts");
const UserStore = new react_light_state_1.default({
    isAuthened: false,
    userinfo: {},
}, "userStore", {
    storageName: consts_1.STORE_KEYS.LIGHT_USER_STORE,
});
exports.default = UserStore;
const { setState, useStore } = UserStore;
exports.useStore = useStore;
function loginSuccessed(userlogonInfo) {
    setState({ userinfo: userlogonInfo, isAuthened: true });
}
exports.loginSuccessed = loginSuccessed;
//# sourceMappingURL=UserStore.js.map